module.exports = __webpack_public_path__ + "static/assets/aab769d1a84d4bb9cd82e18eff1231dd.png";